import { ChangeEvent, FC } from 'react';

type RadioProps = {
  id: string;
  name: string;
  label: string;
  value?: string | number | readonly string[];
  checked: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void; // eslint-disable-line
  className?: string;
};

const Radio: FC<RadioProps> = ({
  id,
  name,
  label,
  value,
  checked,
  disabled,
  onChange,
  className = '',
}) => (
  <div className={`custom-control custom-radio ${className}`}>
    <input
      type="radio"
      className="custom-control-input"
      name={name}
      id={id}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <label className="custom-control-label" htmlFor={id}>
      {label}
    </label>
  </div>
);

export default Radio;
